module.exports = __webpack_public_path__ + "media/Sul.27a56ecd.mp3";